/* kc-clic.js : effet « clic » à l'ajout au panier (nom de la marque). Styles : assets/kc-clic.css.
   - Clic sur un bouton d'ajout (fiche produit / produit vedette, offres comprises ; suggestions du tiroir ; achat rapide) :
     flash blanc bref + obturateur « clic-clac » en Web Audio (aucun fichier) + pression du bouton.
   - cartUpdate (ajout) : le sac de l'en-tête se balance, une fois le tiroir panier (qui le recouvre) refermé.
   - Une fois par ajout : le clic « arme », la mise à jour consomme ; un ajout d'un autre bouton déclenche à la mise à jour
     (si geste utilisateur). prefers-reduced-motion : ni flash ni animation, son plus doux.
   - Ne bloque jamais l'ajout (capture sans preventDefault, try/catch). KC.clic.declencher(bouton?) ; KC.clic.son = false. */
(function () {
  'use strict';
  if (window.__kcClic) return;
  window.__kcClic = true;

  var BOUTONS = [
    '[data-kc-atc]', /* fiche produit + produit vedette (kc-produit) */
    '[data-kc-sugg-ajout]', /* tiroir panier « Vous aimerez aussi » */
    '.kc-qb__atc', /* achat rapide des cartes produit (kc-quickbuy) */
    'product-form [type="submit"][name="add"]' /* boutons Dawn d'origine */
  ].join(',');
  var SOURCES_AJOUT = ['kc', 'product-form', 'quick-add'];
  var DUREE_ARME = 10000; /* ms : délai max entre le clic et la mise à jour du panier qu'il produit */

  var api = { son: true, stats: { declenchements: 0, flashs: 0, sons: 0, secousses: 0 } };
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduit() { return !!(mq && mq.matches); }

  /* ---------------- Son d'obturateur (Web Audio) ---------------- */
  var ctx = null;
  var tampon = null;
  var veille = null;

  function contexte() {
    if (ctx) return ctx;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try { ctx = new AC({ latencyHint: 'interactive' }); } catch (e) {
      try { ctx = new AC(); } catch (e2) { ctx = null; }
    }
    return ctx;
  }

  function bruitBlanc(c) {
    if (tampon && tampon.sampleRate === c.sampleRate) return tampon;
    var n = Math.floor(c.sampleRate * 0.12);
    tampon = c.createBuffer(1, n, c.sampleRate);
    var d = tampon.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
    return tampon;
  }

  /* Une frappe mécanique : bruit filtré à décroissance très rapide + petit corps résonant qui descend. */
  function frappe(c, sortie, t, o) {
    var src = c.createBufferSource();
    src.buffer = bruitBlanc(c);
    var bp = c.createBiquadFilter();
    bp.type = 'bandpass';
    bp.frequency.value = o.freq;
    bp.Q.value = o.q;
    var g = c.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(o.gain, t + 0.0012);
    g.gain.exponentialRampToValueAtTime(0.0001, t + o.duree);
    src.connect(bp);
    bp.connect(g);
    g.connect(sortie);
    src.start(t);
    src.stop(t + o.duree + 0.02);

    var osc = c.createOscillator();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(o.corps, t);
    osc.frequency.exponentialRampToValueAtTime(o.corps * 0.55, t + o.duree);
    var g2 = c.createGain();
    g2.gain.setValueAtTime(0.0001, t);
    g2.gain.exponentialRampToValueAtTime(o.corpsGain, t + 0.002);
    g2.gain.exponentialRampToValueAtTime(0.0001, t + o.duree * 0.9);
    osc.connect(g2);
    g2.connect(sortie);
    osc.start(t);
    osc.stop(t + o.duree + 0.02);
  }

  /* « clic » (le rideau s'ouvre, sec et aigu) puis « clac » 75 ms plus tard (le miroir retombe, plus grave). */
  function jouerObturateur(c, doux) {
    var t = c.currentTime + 0.004;
    var master = c.createGain();
    master.gain.value = doux ? 0.11 : 0.24;
    var sortie = master;
    if (doux) {
      var lp = c.createBiquadFilter();
      lp.type = 'lowpass';
      lp.frequency.value = 2400;
      lp.Q.value = 0.5;
      lp.connect(master);
      sortie = lp;
    }
    master.connect(c.destination);
    frappe(c, sortie, t, { freq: doux ? 3200 : 4300, q: 1.4, gain: 0.9, duree: 0.024, corps: doux ? 1700 : 2300, corpsGain: 0.12 });
    frappe(c, sortie, t + 0.075, { freq: doux ? 1600 : 2100, q: 1.1, gain: 1, duree: 0.048, corps: 210, corpsGain: 0.32 });
    setTimeout(function () { try { master.disconnect(); } catch (e) { /* rien */ } }, 500);
  }

  function obturateur(doux) {
    if (!api.son) return false;
    try {
      var c = contexte();
      if (!c) return false;
      if (c.state === 'suspended' && c.resume) {
        var p = c.resume();
        if (p && p.catch) p.catch(function () { /* audio refusé : silence */ });
      }
      jouerObturateur(c, doux);
      api.stats.sons++;
      /* met l'audio en veille après 2 s de silence (relancé au prochain clic, qui est un geste utilisateur) */
      clearTimeout(veille);
      veille = setTimeout(function () {
        try { if (ctx && ctx.state === 'running' && ctx.suspend) ctx.suspend().catch(function () { /* rien */ }); } catch (e) { /* rien */ }
      }, 2000);
      return true;
    } catch (e) {
      return false;
    }
  }

  /* ---------------- Flash ---------------- */
  var voile = null;

  function flash() {
    if (reduit()) return false;
    try {
      if (!voile || !voile.isConnected) {
        voile = document.createElement('div');
        voile.className = 'kc-clic-flash';
        voile.setAttribute('aria-hidden', 'true');
        voile.addEventListener('animationend', function () { voile.classList.remove('is-on'); });
        document.body.appendChild(voile);
      }
      voile.classList.remove('is-on');
      void voile.offsetWidth; /* relance l'animation si un flash est encore en cours */
      voile.classList.add('is-on');
      clearTimeout(voile.__kcT);
      voile.__kcT = setTimeout(function () { voile.classList.remove('is-on'); }, 700);
      api.stats.flashs++;
      return true;
    } catch (e) {
      return false;
    }
  }

  /* ---------------- Pression du bouton ---------------- */
  function presser(bouton) {
    if (!bouton || reduit()) return;
    try {
      bouton.classList.remove('kc-clic-presse');
      void bouton.offsetWidth;
      bouton.classList.add('kc-clic-presse');
      clearTimeout(bouton.__kcClicP);
      bouton.__kcClicP = setTimeout(function () { bouton.classList.remove('kc-clic-presse'); }, 400);
    } catch (e) { /* rien */ }
  }

  /* ---------------- Icône panier de l'en-tête ---------------- */
  var observateur = null;

  function secouer() {
    var lien = document.getElementById('cart-icon-bubble');
    if (!lien || reduit()) return;
    lien.classList.remove('kc-clic-secousse');
    void lien.offsetWidth;
    lien.classList.add('kc-clic-secousse');
    clearTimeout(lien.__kcClicS);
    lien.__kcClicS = setTimeout(function () { lien.classList.remove('kc-clic-secousse'); }, 800);
    api.stats.secousses++;
  }

  /* Le tiroir panier recouvre l'icône : on attend qu'il soit refermé pour que la secousse se voie. */
  function secouerPanier() {
    if (reduit()) return;
    setTimeout(function () {
      try {
        var tiroir = document.querySelector('cart-drawer');
        if (!tiroir || !tiroir.classList.contains('active')) { secouer(); return; }
        if (observateur) return; /* déjà en attente de fermeture */
        observateur = new MutationObserver(function () {
          if (tiroir.classList.contains('active')) return;
          observateur.disconnect();
          observateur = null;
          setTimeout(secouer, 360); /* fin du glissement du tiroir (0,34 s) */
        });
        observateur.observe(tiroir, { attributes: true, attributeFilter: ['class'] });
      } catch (e) { /* rien */ }
    }, 450);
  }

  /* ---------------- Déclenchement ---------------- */
  var dernier = 0;
  var armes = [];

  function declencher(bouton) {
    var maintenant = Date.now();
    if (maintenant - dernier < 350) return false; /* jamais deux flashs collés */
    dernier = maintenant;
    obturateur(reduit());
    flash();
    presser(bouton);
    api.stats.declenchements++;
    return true;
  }

  function bloque(b) {
    return b.disabled || b.getAttribute('aria-disabled') === 'true' || b.getAttribute('aria-busy') === 'true' ||
      b.classList.contains('is-loading') || b.classList.contains('is-added');
  }

  /* Phase de capture : passe avant les écouteurs d'ajout (qui posent .is-loading) et n'empêche rien. */
  document.addEventListener('click', function (e) {
    try {
      var cible = e.target;
      var bouton = cible && cible.closest ? cible.closest(BOUTONS) : null;
      if (!bouton || bloque(bouton)) return;
      armes.push(Date.now());
      declencher(bouton);
    } catch (err) { /* rien */ }
  }, true);

  /* Appelé de façon synchrone par publish(), juste avant le rendu du tiroir : ne doit jamais lever d'erreur. */
  function surMiseAJour(ev) {
    try {
      if (!ev || SOURCES_AJOUT.indexOf(ev.source) === -1) return;
      if (ev.cartData && ev.cartData.status) return;
      var maintenant = Date.now();
      armes = armes.filter(function (t) { return maintenant - t < DUREE_ARME; });
      if (armes.length) armes.shift(); /* effet déjà joué au clic */
      else if (!navigator.userActivation || navigator.userActivation.isActive) declencher(null);
      secouerPanier();
    } catch (e) { /* rien */ }
  }

  function abonner() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, surMiseAJour);
        return true;
      }
    } catch (e) { /* rien */ }
    return false;
  }
  if (!abonner()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abonner, { once: true });
    else setTimeout(abonner, 0);
  }

  api.declencher = function (bouton) { return declencher(bouton || null); };
  api.flash = flash;
  api.obturateur = function () { return obturateur(reduit()); };
  api.secouer = secouer;
  api.etatAudio = function () { return ctx ? ctx.state : 'aucun'; };
  (window.KC = window.KC || {}).clic = api;
})();
